import {
  CheckOutlined,
  CopyOutlined,
  PaperClipOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import { Idea } from '@frontend/data-access';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { handleOpenDocument } from '@frontend/shared/ui';
import { App } from 'antd';
import useTranslation from 'next-translate/useTranslation';
import { useState } from 'react';

function IdeaDetailAttachments({ idea }: { idea: Idea }) {
  const { notification } = App.useApp();
  const { t } = useTranslation('common');
  const [hasCopied, setHasCopied] = useState<string>();

  const handleCopy = async (text: string) => {
    if ('clipboard' in navigator) {
      await navigator.clipboard.writeText(text);
      setHasCopied(text);
      notification.success({
        message: t('copied_to_clipboard'),
      });
    }
  };

  if (idea.videos?.length !== 0 || (idea.documents && idea.documents.length))
    return (
      <div className="space-y-2">
        <div className="text-gray-700 text-sm font-normal">
          {t('video_attachments')}
        </div>
        <div className="flex flex-wrap gap-2">
          {idea.videos?.map((item, index) => (
            <div
              key={index}
              className="px-3 py-1 bg-gray-300 rounded-full flex items-center gap-2 font-medium cursor-pointer flex-nowrap text-nowrap"
              onClick={() => handleCopy(item as string)}
            >
              <span className="flex items-center">
                <VideoCameraOutlined />
              </span>
              <span>{t('copy_video_link')}</span>
              {hasCopied === item ? <CheckOutlined /> : <CopyOutlined />}
            </div>
          ))}
          {idea.documents &&
            idea.documents?.length > 0 &&
            idea.documents.map((file) => (
              <div
                key={file.id}
                className="px-3 py-1 bg-gray-300 rounded-full flex items-center gap-2 cursor-pointer truncate whitespace-nowrap overflow-hidden"
                onClick={() => handleOpenDocument(file, notification, t)}
              >
                <PaperClipOutlined />
                {`${file.metadata?.filename?.split('.')[0].slice(0, 20)}.${
                  file.metadata?.filename?.split('.')[1]
                }`}
              </div>
            ))}
        </div>
      </div>
    );
  return null;
}

export default IdeaDetailAttachments;
